import React from 'react';
import { PARTNER_PROFILE } from '../Pages';

export default {
  path: PARTNER_PROFILE.pageURL,
  async action() {
    const { default: PartnerProfile } = await import('./PartnerProfile');
    return <PartnerProfile key={'management'} />;
  },
};
